require('./xTick.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

class xTick extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const monthFrom = moment().format('MMMM');
        const { x, y, payload, periodTime} = this.props;
        return(
            <text x={x} y={y + 1} textAnchor="middle" dominantBaseline="hanging" className="x-tick-container">
                {periodTime === 'M' && <tspan className="x-tick-container__span-month" x={x}>{payload.value.substring(0,3)}</tspan>}
                {periodTime === 'D' && <tspan className="x-tick-container__span-month" x={x}>{payload.value}</tspan>}
                {periodTime === 'D' && <tspan className="x-tick-container__span-year" x={x} y={y + 21}>{monthFrom.substring(0,3)}</tspan>}
                {!periodTime && <tspan className="x-tick-container__span-year" x={x}>{payload.value}</tspan> }
            </text>
        )
    }
}

xTick.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    index: PropTypes.number,
    periodTime: PropTypes.string,
    payload: PropTypes.object,
    countLastYear: PropTypes.number
};

module.exports = xTick;
